if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      
                      this.cart.renderContents(response);
                       
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              // alert('ok');
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
                // await syncGiftWrap();
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}



// ✅ GIFT WRAP SYNC FUNCTION (CART PAGE ONLY)
window.syncGiftWrap = async function () {
  if (
    localStorage.getItem("gift_add") !== "true" &&
    localStorage.getItem("giftWrapChecked") !== "true"
  ) return;

  // Only run on cart page
  if (!window.location.pathname.includes('/cart')) return;

  const GIFT_WRAP_VARIANT_ID = 46982580437184;

  try {
    const cart = await fetch('/cart.js').then(r => r.json());

    const wrapItem = cart.items.find(i => i.variant_id === GIFT_WRAP_VARIANT_ID);

    const totalProducts = cart.items
      .filter(i => i.variant_id !== GIFT_WRAP_VARIANT_ID)
      .reduce((sum, i) => sum + i.quantity, 0);

    const neededWraps = totalProducts <= 0 ? 0 : Math.floor((totalProducts - 1) / 4) + 1;

    // Update / Add / Remove gift wrap
    if (neededWraps === 0 && wrapItem) {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: wrapItem.key, quantity: 0 }),
      });
    } else if (!wrapItem && neededWraps > 0) {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{ id: GIFT_WRAP_VARIANT_ID, quantity: neededWraps }],
        }),
      });
    } else if (wrapItem && wrapItem.quantity !== neededWraps) {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: wrapItem.key, quantity: neededWraps }),
      });
    }

    // 🔄 Render cart sections via AJAX (like your original cart page code)
    const cartItemsRes = await fetch(`${routes.cart_url}?section_id=main-cart-items`);
    const cartItemsHTML = await cartItemsRes.text();
    const docItems = new DOMParser().parseFromString(cartItemsHTML, 'text/html');

    const newCartItems = docItems.querySelector('cart-items');
    const currentCartItems = document.querySelector('cart-items');
    if (newCartItems && currentCartItems) currentCartItems.innerHTML = newCartItems.innerHTML;

    const footerRes = await fetch(`${routes.cart_url}?section_id=main-cart-footer`);
    const footerHTML = await footerRes.text();
    const docFooter = new DOMParser().parseFromString(footerHTML, 'text/html');

    const newFooter = docFooter.querySelector('cart__footer');
    const currentFooter = document.querySelector('cart__footer');
    if (newFooter && currentFooter) currentFooter.innerHTML = newFooter.innerHTML;

    // Update cart bubble
    const bubble_t = document.querySelector('.cart_bbl');
    if (bubble_t) bubble_t.innerHTML = cart.item_count;

    console.log('✅ Gift wrap synced and cart updated via AJAX');
  } catch (error) {
    console.error('❌ Gift wrap sync failed:', error);
  }
};

